module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-5.e7d4e8d2.jpg";